/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CertRosetteAltIcon20Regular = forwardRef('CertRosetteAltIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 1a6 6 0 0 0-4 10.472v6.466c0 .918 1.01 1.476 1.787.988L10 17.536l2.213 1.39A1.167 1.167 0 0 0 14 17.938v-6.466A6 6 0 0 0 10 1ZM5.5 7a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm7 5.456A5.978 5.978 0 0 1 10 13a5.978 5.978 0 0 1-2.5-.544v4.879l1.88-1.18c.379-.24.861-.24 1.24 0l1.88 1.18v-4.879Z" })));
});
